import { FamilyApplicationEndpoints } from "@/apis/family_application/requests"
import { parseRequestError } from "@/app/common/utilities"
import axiosInstance from "@/libs/axios_config"
import { useMutation } from "@tanstack/react-query"
import { z } from "zod"
  
const PostRespSchema = z.array(z.object({
    id: z.number(),
    path: z.string(),
}))

export type PostResp = z.infer<typeof PostRespSchema>

// Define the custom hook
export const usePostRelationshipDocument = () => {
    return useMutation<PostResp, Error, FormData>({
        mutationFn: async (payload: FormData) => {
            try {
                const response = await axiosInstance.post(
                    FamilyApplicationEndpoints.post_relationship,
                    payload,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                )
                return PostRespSchema.parse(response.data)
            } catch (error) {
                throw parseRequestError(error)
            }
        },
    })
}
